import React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import {graphql, useStaticQuery} from 'gatsby';
import VirtualReception from '../layouts/VirtualReception';


const VirtualReceptionFr = () => {
  const data = useStaticQuery(graphql`
    query virutalReceptionDatasFr {
      image: file(relativePath: { eq: "touch/header.jpg"}) {
        id
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allContentfulTypeDeTactile(sort: {fields: position, order: ASC}, filter: {node_locale: {eq: "fr-CA"}}) {
        edges {
          node {
            name
            functionalities
            gif {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
      allContentfulTactile {
        edges {
          node {
            installations {
              gatsbyImageData(layout: CONSTRAINED)
            }
            clients {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `)
  return (
    <Layout 
    lang="fr-CA" 
    switchLink='/en/virtual-reception'
    slider={true}
    headerImage={data.image.childImageSharp} 
    headerImageAlt="Reception virtuel Attractif"
    title="Simplifiez l’arrivée de vos visiteurs" 
    subTitle="Un accueil automatisé, efficace et économique, où vos visiteurs s’annoncent en quelques secondes." 
    anchorLink="#touch-projects-types">
      <Seo 
        title="Réception virtuelle | Simplifiez l’accueil de vos visiteurs"
        description="Simplifiez l’arrivée de vos visiteurs grâce à une réception virtuelle autonome. Un accueil professionnel, sans réceptionniste et à moindre coût."
       />
      <VirtualReception lang="fr-CA" types={data.allContentfulTypeDeTactile} carouselDatas={data.allContentfulTactile.edges[0].node}/>
    </Layout>
  )
}

export default VirtualReceptionFr;
